// Inject a per-card trash button on each `.oc` card in a bulk-tool container (Express
// Schema / Express Internal Links) and wire it to removeCard via the anchored confirm
// popover. The cards are server-rendered into AuditSection (no per-card trash markup), so
// we add it client-side here. Placed at the bottom of the card's action column (right side);
// error cards with no action column get an absolute top-right button.
import { confirmDeletePopover } from "./confirmPopover";

export const TRASH_SVG = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>`;

// Remove the "Ignore" action (and its adjacent separator) from every card under `root`.
// Used by the Express tabs, where there's nothing to ignore. Idempotent — safe per render,
// and it also cleans older cached cards that were built with an Ignore checkbox.
export function stripIgnoreControls(root: HTMLElement): void {
  root.querySelectorAll<HTMLElement>("label.ac-chk").forEach(lbl => {
    if (!/ignore/i.test(lbl.textContent ?? "")) return;
    const prev = lbl.previousElementSibling;
    if (prev?.classList.contains("ac-sep")) prev.remove();
    else if (lbl.nextElementSibling?.classList.contains("ac-sep")) lbl.nextElementSibling.remove();
    lbl.remove();
  });
}

export function wireCardTrash(root: HTMLElement, removeCard: (cardId: string) => void): () => void {
  stripIgnoreControls(root); // Express cards have no "Ignore"
  const cleanups: Array<() => void> = [];
  root.querySelectorAll<HTMLElement>('.oc[id^="oc-"]').forEach(card => {
    const id = card.id;
    if (!id) return;
    let btn = card.querySelector<HTMLButtonElement>(".express-card-trash, .express-card-trash-abs");
    if (!btn) {
      btn = document.createElement("button");
      btn.type = "button";
      btn.title = "Remove this card";
      btn.setAttribute("aria-label", "Remove this card");
      btn.innerHTML = TRASH_SVG;
      const ac = card.querySelector(".ac");
      if (ac) {
        btn.className = "cd-trash-btn express-card-trash"; // inline at the end of the action row
        ac.appendChild(btn);
      } else {
        btn.className = "cd-trash-btn express-card-trash-abs"; // error card → absolute top-right
        card.style.position = "relative";
        card.appendChild(btn);
      }
    }
    const trash = btn;
    const h = (e: Event) => { e.preventDefault(); e.stopPropagation(); confirmDeletePopover(trash, () => removeCard(id)); };
    trash.addEventListener("click", h);
    cleanups.push(() => trash.removeEventListener("click", h));
  });
  return () => cleanups.forEach(fn => fn());
}
